<template lang="pug">

  footer(role="contentinfo")
    .layout
      .explanation
        p Replace letters with emojis that look like letters, if you want.
        p Type your wurds in the light box above, and hit copy to take them somewhere else.

      small ©2018
        |
        |
        a._unlink(rel="author" href="http://jasonhibbs.co.uk") Jason Mervyn Hibbs

</template>
<script>

export default {
  name: 'AppFooter',
};

</script>
